module.exports = "https://cdn.hellotech.com/client-assets/thermostats_mobile_35af3ed0a44a90724fc7a09bb1eb89e7.png";